import Vue from 'vue'
import Vuex from 'vuex'

import jsonFlow from '@/json/flow'
import jsonContent from '@/json/content'
import jsonReport from '@/json/report'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    q: -1,
    formData: {},
    flow: jsonFlow,
    content: jsonContent,
    reporting: jsonReport,
    choice: false
  },
  getters: {
    //nextQ(state)
  },
  mutations: {
    setQ(state,payload) {
      this.state = payload;
    },
    response(state,payload) {
      this.state.formData.push(payload);
    },
    setFormData(state, payload) {
      //console.log(payload);
      let score = payload.score ? payload.score : 0;
      let report = payload.report ? payload.report : false;
      state.formData[payload.prop] = { group: payload.group, value: payload.value, score: score, report: report, id: payload.id, serial: payload.serial };
    },
    setFormGroupData(state, payload) {
      if(!state.formData[payload.group]) {
        state.formData[payload.group] = [];
      }
      if (state.formData[payload.group]) {
        state.formData[payload.group].push({[payload.prop]: payload.value});
      }

      //state.formData[payload.group] = Array.from(new Set(state.formData[payload.group]));
    },
    setNext(state, payload) {
      state.choice = payload;
    }
  },
  actions: {

  }
})
